import React from "react";
import { Award, ShieldCheck, Clock, Star } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";

const ITEMS = [
  { icon: Award, stat: "20+ Years", label: "of trusted building experience" },
  { icon: ShieldCheck, stat: "Licensed & Insured", label: "fully certified tradespeople" },
  { icon: Clock, stat: "On Time, On Budget", label: "delivered with clear communication" },
  { icon: Star, stat: "Warranty Backed", label: "quality craftsmanship guaranteed" },
];

export default function WhyChoose() {
  const ref = useReveal();
  return (
    <section className="bg-homi-black" data-testid="why-choose-strip">
      <div className="max-w-7xl mx-auto px-6 py-10 lg:py-12">
        <div ref={ref} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.stat}
                data-testid={`why-choose-item-${i}`}
                className="reveal flex items-center gap-4"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <span className="shrink-0 w-12 h-12 rounded-xl bg-homi-gold/15 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-homi-gold" />
                </span>
                <div>
                  <div className="font-heading font-bold text-white text-lg leading-tight">{it.stat}</div>
                  <div className="text-white/60 text-sm">{it.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
